module.exports = __webpack_public_path__ + "img/docx.2cd1f857.svg";